export default {
    'journal-number-automatic-or-manual': 'Número diario automático o manual',
    warehouse: 'Almacén',
    add: 'Añadir',
    delete: 'Eliminar',
    save: 'Guardar',
    edit: 'Editar',
    'view-invoice': 'Mostrar factura',
    'view-manufacturing-bond': 'Mostrar documento de fabricación',
    not: 'No',
    posted: 'Publicado',
    'add-journal': 'Añadir diario',
    'journal-date': 'Fecha de diario',
    create: 'Crear',
    cancel: 'Cancelar',

    'delete-entry': 'Eliminar asiento contable',
    'are-you-sure-you-want-to-delete-the-entry': '¿Estas seguro de eliminar el asiento?',

    'delete-journal': 'Eliminar diario',
    'are-you-sure-you-want-to-delete-the-journal': '¿Estas seguro de eliminar diario?',
    
    'make-sure-the-data-entered-is-correct': 'Verificar los datos ingresados',

    headers: {
        'no': 'De serie',
        'in-quantity': 'Cantidad entrante',
        'out-quantity': 'Cantidad saliente',
        'warehouse': 'Almacén',
        'material': 'Artículo',
        'count': 'Conteo',
        'price': 'Precio',
        'notes': 'Descripción',
        'document': 'Ref. Doc.',
        'account': 'Cuenta',
        'date': 'Fecha',
    },

    'context-menu': {
        'material-statement': 'Estado de artículo',
        'edit': 'Editar',
        'delete-item': 'Eliminar',
    }
}